import React from 'react';
import PropTypes from 'prop-types';
import MobileDate from 'components/MobileFilters/MobileDate';
import MobileWeekFilter from 'components/MobileFilters/MobileWeekFilter';
import Close from '../../assets/Close.svg';
import './mobile-date-filter-modal.scss';


const MobileDateFilterModal = ({ modalOpen, onClose, dates, selectDate, selectWeek, selectedDate, weeks, selectedWeek, brandClass }) => (
  <div className={`react-date-filter-mobile-modal${modalOpen ? '' : ' none'}`}>
    <div className="react-date-filter-mobile-modal-header">
      <div className={`react-date-filter-mobile-modal-header-title react-mozi-brand ${brandClass}`}>Válassz napot!</div>
      <Close onClick={() => { onClose(); }} />
    </div>
    <MobileWeekFilter
      weeks={weeks}
      onChange={(week) => { selectWeek(week); }}
      selectedWeek={selectedWeek}
      brandClass={brandClass}
    />
    <div className="react-date-filter-mobile-boxes-container">
      {dates.map(date => (!date.disabledDate ? (
        <MobileDate
          key={date.date}
          id={date.dateId}
          date={date.date}
          day={date.day}
          onClick={() => { selectDate(date.dateId); onClose(); }}
          selectedDate={selectedDate}
          brandClass={brandClass}
        />
      ) : null))}
      <div className="react-date-filter-mobile-box-placeholder" />
      <div className="react-date-filter-mobile-box-placeholder" />
      <div className="react-date-filter-mobile-box-placeholder" />
      <div className="react-date-filter-mobile-box-placeholder" />
      <div className="react-date-filter-mobile-box-placeholder" />
    </div>
  </div>
);

MobileDateFilterModal.propTypes = {
  brandClass: PropTypes.string,
  modalOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectDate: PropTypes.func.isRequired,
  selectWeek: PropTypes.func.isRequired,
  selectedDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]).isRequired,
  selectedWeek: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  dates: PropTypes.arrayOf(PropTypes.shape({})),
  weeks: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
};

MobileDateFilterModal.defaultProps = {
  weeks: null,
  dates: null,
  selectedWeek: null,
  brandClass: 'react-artmozi',
};

export default MobileDateFilterModal;
